module.exports = __webpack_public_path__ + "122fb9b244208f8218bedcbc725bf854.MP3";